import { useTranslation } from "react-i18next";
import React, { FC } from "react";
import { Checkbox } from "@evergis/ui";

import { UsersInfo } from "./UsersInfo";
import { CheckboxContainer } from "../styled";
import { RequestDependencyInfo, RequestInfoType } from "./RequestInfo";
import { CheckedDeleteResourcesState, ToggleDeleteResources } from "../hooks/useDeleteResourcesChoice";
import { ResourcesResolved } from "../resolveResources";

type DeleteProjectsContentProps = {
  checked: CheckedDeleteResourcesState;
  toggle: ToggleDeleteResources;
} & ResourcesResolved;

export const DeleteProjectsContent: FC<DeleteProjectsContentProps> = ({
  projects,
  layers,
  tables,
  checked,
  toggle,
}) => {
  const { t } = useTranslation("dialogs");
  const showLayerCheckbox = layers.length > 0;
  const showSourceCheckbox = tables.length > 0;

  return (
    <>
      {showLayerCheckbox && (
        <>
          <CheckboxContainer>
            <Checkbox
              checked={checked.layers}
              label={t("deleteResources.deleteLayersFromCatalog")}
              onChange={toggle.layers}
            />
          </CheckboxContainer>
          <RequestDependencyInfo
            type={RequestInfoType.MapsWithLayers}
            projects={projects}
            layers={layers}
            tables={tables}
          />
          <UsersInfo layers={layers} />
        </>
      )}

      {showSourceCheckbox && (
        <>
          <CheckboxContainer>
            <Checkbox
              checked={checked.tables}
              label={t("deleteResources.deleteDataSources")}
              onChange={toggle.tables}
            />
          </CheckboxContainer>
          <RequestDependencyInfo
            type={RequestInfoType.MapsWithTables}
            projects={projects}
            layers={layers}
            tables={tables}
          />
          <RequestDependencyInfo
            type={RequestInfoType.LayersWithTables}
            projects={projects}
            layers={layers}
            tables={tables}
          />
        </>
      )}
    </>
  );
};
